{
  "Accessibility Menu": "Meniu de accesibilitate",
  "Reset settings": "Resetează setările",
  "Close": "Închide",
  "Content Adjustments": "Ajustări conținut",
  "Adjust Font Size": "Ajustează dimensiunea fontului",
  "Highlight Title": "Evidențiază titlul",
  "Highlight Links": "Evidențiază legăturile",
  "Readable Font": "Font lizibil",
  "Color Adjustments": "Ajustări de culoare",
  "Dark Contrast": "Contrast întunecat",
  "Light Contrast": "Contrast luminos",
  "High Contrast": "Contrast ridicat",
  "High Saturation": "Saturație ridicată",
  "Low Saturation": "Saturație redusă",
  "Monochrome": "Monocrom",
  "Contrast": "Contrast",
  "Invert Colors": "Inversează culorile",
  "Tools": "Instrumente",
  "Reading Guide": "Ghid de lectură",
  "Stop Animations": "Opriți animațiile",
  "Big Cursor": "Cursor mare",
  "Increase Font Size": "Mărește dimensiunea fontului",
  "Decrease Font Size": "Micșorează dimensiunea fontului",
  "Letter Spacing": "Spațierea literelor",
  "Line Height": "Înălțimea liniei",
  "Font Weight": "Grosimea fontului",
  "Dyslexia Font": "Font pentru dislexie",
  "Language": "Limbă",
  "Open Accessibility Menu": "Deschideți meniul de accesibilitate",
  "Widget Settings": "Setări widget",
  "Widget Position": "Poziția widgetului",
  "Top Left": "Stânga sus",
  "Top Center": "Sus centru",
  "Top Right": "Dreapta sus",
  "Center Left": "Centru stânga",
  "Center Right": "Centru dreapta",
  "Bottom Left": "Stânga jos",
  "Bottom Center": "Jos centru",
  "Bottom Right": "Dreapta jos",
  "Screen Reader": "Cititor de ecran",
  "Voice Navigation": "Navigare vocală",
  "Custom Color": "Culoare personalizată",
  "Change the site's colors": "Schimbă culorile site-ului",
  "Backgrounds": "Fundaluri",
  "Headings": "Titluri",
  "Contents": "Conținuturi",
  "Reset colors": "Resetează culorile",
  "Image Desaturation": "Desaturarea imaginii",
  "Search languages": "Caută limbi",
  "No languages found": "Nu s-au găsit limbi",
  "Accessibility Profiles": "Profiluri de accesibilitate",
  "Motor Impaired": "Dificultăți motorii",
  "Big cursor, voice navigation, and no animations.": "Cursor mare, navigare vocală și fără animații.",
  "Blind": "Nevăzător",
  "Screen reader helpers with higher contrast.": "Asistenți pentru cititorul de ecran cu contrast ridicat.",
  "Color Blind": "Daltonism",
  "High contrast palette with desaturated media.": "Paletă cu contrast înalt și media desaturată.",
  "Dyslexia": "Dislexie",
  "Friendly font, extra spacing, stronger weight.": "Font ușor de citit, spațiere suplimentară și grosime mai mare.",
  "Low vision": "Vedere slabă",
  "Dark contrast and 130% magnification.": "Contrast întunecat și mărire de 130%.",
  "Cognitive & Learning": "Cognitiv și învățare",
  "Highlights key sections and enables voice help.": "Evidențiază secțiunile cheie și activează ajutorul vocal.",
  "Seizure & Epileptic": "Convulsii și epilepsie",
  "Stops animations and desaturates imagery.": "Oprește animațiile și estompează imaginile.",
  "ADHD": "ADHD",
  "Reading guide, highlighted links, calmer palette.": "Ghid de citire, link-uri evidențiate și paletă mai calmă.",
  "Widget Size": "Widget Size",
  "Default": "Default",
  "Medium": "Medium",
  "Small": "Small",
  "Color Blindness": "Color Blindness",
  "Protanopia": "Protanopia",
  "Deuteranopia": "Deuteranopia",
  "Tritanopia": "Tritanopia",
  "Achromatopsia": "Achromatopsia",
  "Simulates and assists users with color vision deficiencies.": "Simulates and assists users with color vision deficiencies."
}
